"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderProductItemPlus = exports.OrderProductItem = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _logger = require("@ori/logger");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _logger2 = require("../../logger");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OrderProductItemInner = (param)=>{
    let { itemCode, isHidden } = param;
    const theme = (0, _mui.useTheme)();
    const { getTestId } = (0, _testidGenerator.default)();
    const imageUrl = (0, _hooks.useProductInfo)(itemCode);
    const image = isHidden ? 'surprise' : imageUrl;
    (0, _logger2.logDebug)('OrderProductItemInner \r\n⤵️ itemCode: ', itemCode, '\r\n isHidden: ', isHidden, '\r\n imageUrl: ', imageUrl, '\r\n image: ', image);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
        component: _styles.OrderProductBase,
        src: image,
        "data-testid": getTestId('order-item'),
        alt: itemCode,
        background: theme.palette.grey.A100,
        width: "100%",
        height: "80px"
    });
};
const OrderProductItem = (param)=>{
    let { itemCode, quantity, isHidden } = param;
    const theme = (0, _mui.useTheme)();
    const showImage = Boolean(itemCode || isHidden);
    const childLogger = _logger2.mainLogger.createChild('OrderProductItemInner');
    (0, _logger2.logDebug)('OrderProductItem \r\n➡️ itemCode: ', itemCode, '\r\n isHidden: ', isHidden, '\r\n quantity: ', quantity, '\r\n showImage: ', showImage);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.OrderProductItemWrapper, {
        children: [
            quantity > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Quantity, {
                variant: "body1",
                children: quantity
            }) : null,
            showImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "OrderProductItemInner",
                logger: childLogger,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrderProductItemInner, {
                    itemCode: itemCode,
                    isHidden: isHidden
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
                component: _styles.OrderProductBase,
                src: "noImage",
                alt: "",
                background: theme.palette.grey.A100,
                width: "100%",
                height: "80px"
            })
        ]
    });
};
exports.OrderProductItem = OrderProductItem;
const OrderProductItemPlus = (param)=>{
    let { plusCount } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.OrderProductPlusWrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
            color: "textSecondary",
            children: [
                "+",
                plusCount
            ]
        })
    });
};
exports.OrderProductItemPlus = OrderProductItemPlus;
